import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';
import style from './style.scss';
import utils from 'Utils/index.js';
import Loading from "../../common/Loading/Loading";

const alert_sound = new Audio('audio/notification.wav');

window.alert_sound = alert_sound;

const calls_hash = {};

export default class CallbacksList extends Component{

  constructor(props) {
    super(props);

    this.state = {
    };

  }

  componentDidUpdate(){
    const {data: {loading, callbacks}, app_data, calls} = this.props;

    !loading && JSON.parse(callbacks.json).forEach(call => {

      if(!calls_hash[call.id]){
        alert_sound.readyState === 4 && alert_sound.play();
        calls_hash[call.id] = true;
      }

    });
  }

  render() {

    const {data: {loading, callbacks}, app_data, calls} = this.props;

    if(loading ) {
      return (<Loading/>);
    }


    const calls_phones_map = _.keyBy(calls, 'phone');

    const callbacks_list = _.slice(JSON.parse(callbacks.json),0,8).map(callback => {

      const phone_format = callback.phone.replace(/[\(\)\+ \-]/g, '');
      const moment_new = moment().add(-13, 'hours');
      const moment_callback = moment(callback.date, utils.DATE_FORMAT_WITH_TIME);
      const is_new = moment_new.isBefore(moment_callback);

      if(!calls_phones_map[phone_format] && is_new) {
        callback.not_called = true;
      }

      return callback;

    });

    return (
      <div className={`callbacks`}>

        <h1>Заявки</h1>

        <table className={`table fixed full_width`}>

          <thead className={`table__thead`}>

          <tr>

            <th className="callbacks__th_date"></th>
            <th className="callbacks__th_phone"></th>
            <th className="callbacks__th_type"></th>
            <th className="callbacks__th_page"></th>
            <th className="callbacks__th_page"></th>

          </tr>

          </thead>

          <tbody>

          {callbacks_list.map(({
            id,
            date,
            phone,
            callback_type,
            page_title,
            page_url,
            not_called
          }) => {

            const phone_format = phone.replace(/[\(\)\+ \-]/g, '');

            const not_called_class = not_called ? 'callbacks_list_item__not_called' : '';

            return (<tr key={id} className={`${not_called_class}`}>
              <td
                className="callbacks_list_item__td callbacks_list_item__td_date"
              >
                {date}
              </td>

              <td
                className="callbacks_list_item__td callbacks_list_item__td_phone"
              >
                {phone_format}
              </td>

              <td
                className="callbacks_list_item__td callbacks_list_item__td_type"
              >
                {callback_type}
              </td>

              <td className="callbacks_list_item__td callbacks_list_item__td_page">
                {page_title}
              </td>

              <td className="callbacks_list_item__td">
                {page_url}
              </td>
            </tr>);

          })}

          </tbody>

        </table>

      </div>
    );
  }
}

